<div class="dialog-wrapper">
    <h3 mat-dialog-title>{{ data.title }}</h3>
    <div mat-dialog-content>
        @if (data.message) {
        <div class="text">{{ data.message }}</div>
        }
        <div [formGroup]="form" class="reset-password-form">
            <mat-form-field appearance="outline" class="password-field">
                <mat-label>{{ 'app.user.actions.reset_password.dialog.password_label' | translate }}</mat-label>
                <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" />
                <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
                    <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <button mat-icon-button matSuffix type="button" (click)="regeneratePassword()"
                    [matTooltip]="'app.user.actions.reset_password.dialog.regenerate' | translate">
                    <mat-icon>refresh</mat-icon>
                </button>
            </mat-form-field>
            <mat-checkbox formControlName="forceChangePasswordNextSignIn">
                {{ 'app.user.actions.reset_password.dialog.force_change' | translate }}
            </mat-checkbox>
        </div>
    </div>
    <div mat-dialog-actions>
        <div class="dialog-actions">
            <button mat-raised-button class="cancelButton" (click)="onCancel()">
                <span>{{ 'shared.general.buttons.cancel' | translate }}</span>
            </button>
            <button mat-flat-button color="primary" class="confirmButton" (click)="onSubmit()">
                <span>{{ 'shared.general.buttons.confirm' | translate }}</span>
            </button>
        </div>
    </div>
</div>